var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffericon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.7511C0 15.078 14.3269 0.751099 32 0.751099C49.6731 0.751099 64 15.078 64 32.7511C64 50.4242 49.6731 64.7511 32 64.7511C14.3269 64.7511 0 50.4242 0 32.7511Z",
    fill: "#0675F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 24.7511C19.4667 25.4178 20.2667 26.0845 22.0001 26.0845C25.3334 26.0845 25.3334 23.4178 28.6667 23.4178C32.1334 23.4178 31.8667 26.0845 35.3334 26.0845C38.6667 26.0845 38.6667 23.4178 42.0001 23.4178C43.7334 23.4178 44.5334 24.0845 45.3334 24.7511",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 32.7511C19.4667 33.4178 20.2667 34.0845 22.0001 34.0845C25.3334 34.0845 25.3334 31.4178 28.6667 31.4178C32.1334 31.4178 31.8667 34.0845 35.3334 34.0845C38.6667 34.0845 38.6667 31.4178 42.0001 31.4178C43.7334 31.4178 44.5334 32.0845 45.3334 32.7511",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 40.7511C19.4667 41.4178 20.2667 42.0845 22.0001 42.0845C25.3334 42.0845 25.3334 39.4178 28.6667 39.4178C32.1334 39.4178 31.8667 42.0845 35.3334 42.0845C38.6667 42.0845 38.6667 39.4178 42.0001 39.4178C43.7334 39.4178 44.5334 40.0845 45.3334 40.7511",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffericon2);
export default __webpack_public_path__ + "static/media/offericon2.b784c5213c5bc282d0d8e8ac6bbc8881.svg";
export { ForwardRef as ReactComponent };